import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
	handleError,
	handleSuccess,
	handleWarning,
} from '../../../helpers/utils';
import { Autocomplete, Grid, TextareaAutosize } from '@mui/material';
import { registerAnnotation } from '../../../actions/annotation';
import { ANNOTATION_TYPES } from '../../utils/lists';
import { useSelector } from 'react-redux';

export const AnnotationForm = ({
	open,
	handleClose,
	subbiasId,
	refresh,
	collapseClose,
	changeKeyAccordion,
}) => {
	const [noteType, setNoteType] = React.useState(null);
	const [notes, setNotes] = React.useState('');

	// User
	const { user } = useSelector((state) => state);

	const handleSave = () => {
		if (noteType !== null && notes.length >= 0) {
			handleClose();
			changeKeyAccordion('no');
			registerAnnotation({
				type: ANNOTATION_TYPES.find((item) => item.label === noteType)
					.name,
				description: notes,
				created_by: user.id,
				subbias: parseInt(subbiasId),
			})
				.then(() => {
					handleSuccess('Anotación creada');
					collapseClose(true);
					changeKeyAccordion(`subbias-${subbiasId}`);
					refresh();
				})
				.catch((error) => {
					handleError(error, 'No se pudo crear la anotación');
				})
				.finally(() => {
					setNoteType(null);
					setNotes('');
				});
		} else {
			handleWarning('Faltan campos por completar');
		}
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	return (
		<Dialog open={open} onClose={handleClose} maxWidth='xs'>
			<DialogTitle>Anotación</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Seleccione algún tipo de anotación y escriba su comentario.
				</DialogContentText>
				<Grid container spacing={2} className='mt-2'>
					<Grid item xs={12}>
						<Autocomplete
							required
							style={{ marginTop: '-15px' }}
							fullWidth
							value={noteType}
							onChange={(_, value) => {
								setNoteType(value);
							}}
							options={[
								'Observación',
								'Compromiso',
								'Estrategia',
							]}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tipo de anotación')
							}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextareaAutosize
							value={notes}
							onChange={({ target }) => setNotes(target.value)}
							aria-label='minimum height'
							minRows={5}
							variant='standard'
							placeholder='Escribe aquí tu anotación'
							style={{
								width: '100%',
								borderRadius: '8px',
								height: 100,
								fontFamily: 'Arial',
								fontSize: '17px',
								marginTop: '-5px',
								padding: '10px',
								borderColor: '#E1DEDD',
							}}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						setNoteType(null);
						setNotes('');
						handleClose();
					}}
				>
					Cancelar
				</Button>
				<Button onClick={handleSave}>Guardar</Button>
			</DialogActions>
		</Dialog>
	);
};
